import { useEffect, useRef, useState } from "react";
import { Fireworks } from "fireworks-js";

const FireworksEffect = ({ trigger, message = "5 correct in a row!" }) => {
    const containerRef = useRef(null);
    const fireworksInstance = useRef(null);
    const [showText, setShowText] = useState(false);

    useEffect(() => {
        if (containerRef.current) {
            fireworksInstance.current = new Fireworks(containerRef.current, {
                rocketsPoint: { min: 0, max: 100 },
                hue: { min: 0, max: 360 },
                delay: { min: 15, max: 30 },
                speed: 2,
                acceleration: 1.05,
                friction: 0.95,
                gravity: 1.5,
                particles: 50,
                trace: 3,
                explosion: 5,
                autoresize: true,
            });
        }
    }, []);

    useEffect(() => {
        if (trigger && fireworksInstance.current) {
            fireworksInstance.current.start();
            setShowText(true);

            setTimeout(() => {
                fireworksInstance.current.stop();
                setShowText(false);
            }, 2000); // 3s biến mất
        }
    }, [trigger]);

    return (
        <div
            ref={containerRef}
            style={{
                position: "fixed",
                width: "100vw",
                height: "100vh",
                top: 0,
                left: 0,
                pointerEvents: "none",
                zIndex: 9999,
            }}
        >
            {showText && (
                <div
                    style={{
                        position: "absolute",
                        top: "40%",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "3rem",
                        fontWeight: "bold",
                        color: "#fff",
                        textShadow: "2px 2px 10px #000",
                        animation: "fadeInOut 1s ease",
                    }}
                >
                    {message}
                </div>
            )}

            <style>
                {`
          @keyframes fadeInOut {
            0% { opacity: 0; transform: scale(0.8); }
            20% { opacity: 1; transform: scale(1.1); }
            80% { opacity: 1; transform: scale(1); }
            100% { opacity: 0; transform: scale(0.8); }
          }
        `}
            </style>
        </div>
    );
};

export default FireworksEffect;
